document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById("calendar-app")) {
        new Vue({
            el: '#calendar-app',
            data: {
                heading: 'Your Heading Here',
                events: [],
                selectedEvent: null,
                skip: 0,
                take: 3,
                allEventsLoaded: false,
                modalOpen: false
            },
            created() {
                this.fetchEvents(true);
            },
            methods: {
                fetchEvents(initialLoad) {
                    fetch(`/api/calendar/events?skip=${this.skip}&take=${this.take}`)
                        .then(response => response.json())
                        .then(data => {
                            //console.log(data)
                            if (!initialLoad) {
                                this.allEventsLoaded = true;
                            }
                            this.events = [...this.events, ...data];
                            this.take = 0;
                        })
                        .catch(error => console.error('Error fetching events:', error));
                },
                loadMore() {
                    this.skip += 3;
                    this.fetchEvents();
                },
                openModal(event) {
                    this.selectedEvent = event;
                    this.$refs.modal.showModal();
                    this.modalOpen = true;
                },
                closeModal() {
                    this.modalOpen = false;
                    var $self = this;
                    setTimeout(() => {
                        $self.$refs.modal.close();
                    }, 500)
                },
            },
        });
    }
});
